import PropTypes from 'prop-types';

const projectShape = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  importInProgress: PropTypes.bool,
});

export default projectShape;
